module.exports = __webpack_public_path__ + "img/bg3.0c806603.png";